import { AbstractReportPmsApiService } from '../abstract-report.service';
import { MunicipalityFeesReport } from '../../../models/reports/financial/municipality-fees-report.model';

/**
 * @class MunicipalityFeesReportPmsApiService
 * @extends {AbstractReportPmsApiService<MunicipalityFeesReport>}
 */
export class MunicipalityFeesReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/financial/municipality-fees';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {MunicipalityFeesReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new MunicipalityFeesReport(attributes);
    }

    /**
     * Send report to Balady
     *
     * @param {Property} property
     * @param {Object} params
     * @returns {Promise.<Object>}
     */
    sendReport(property, params) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url + '/send-report', params, {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/municipality-fees-report.service.js